oyc.Popup = {
  selectors: {
    container: '.news-popup',
    closeBtn: '.news-popup--close',
  },
  activeClass: 'is-show',
  showDelay: 3000,
  autoCloseDelay: 600000,
  showTimer: null,
  closeTimer: null,
  container: null,

  init: function () {
    this.container = document.querySelector(this.selectors.container);

    if (this.container) {
      if (parseInt(oyc.DocCookies.getItem('popup-shown')) !== parseInt(this.container.dataset.newsUid)) {
        this.bindEvents();
        this.scheduleShow();
      }
    }
  },

  scheduleShow: function () {
    this.showTimer = setTimeout(
      this.show.bind(this),
      this.showDelay
    );
  },

  show: function () {
    this.container.classList.add(this.activeClass);
    this.closeTimer = setTimeout(
      this.hide.bind(this),
      this.autoCloseDelay
    );
  },

  hide: function () {
    this.container.classList.remove(this.activeClass);
    this.clearTimers();
  },

  closeByButton: function (ev) {
    ev.preventDefault();
    this.storeCookie();
    this.hide();
  },

  clearTimers: function () {
    if (this.showTimer) {
      clearTimeout(this.showTimer);
    }
    if (this.closeTimer) {
      clearTimeout(this.closeTimer);
    }
  },

  bindEvents: function () {
    this.container.querySelector(this.selectors.closeBtn).addEventListener('click', this.closeByButton.bind(this));
  },

  destroy: function () {
    this.clearTimers();
    this.container.querySelector(this.selectors.closeBtn).removeEventListener('click', this.closeByButton.bind(this));
    this.container.classList.remove(this.activeClass);
  },
  storeCookie: function () {
    oyc.DocCookies.setItem('popup-shown', this.container.dataset.newsUid, Infinity);
  }
}
